module.exports = __webpack_public_path__ + "static/img/operate-.6afba7b7.svg";